import { render, staticRenderFns } from "./AboutSundairBox.vue?vue&type=template&id=aed4fc6a&scoped=true"
import script from "./AboutSundairBox.vue?vue&type=script&lang=js"
export * from "./AboutSundairBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed4fc6a",
  null
  
)

export default component.exports